import * as React from "react"
import { createFileRoute } from "@tanstack/react-router"

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from "@/components/ui/credenza"
import CommodityRateForm from "@/components/forms/commodity-rates"
import ConnectionStatusForm from "@/components/forms/connection-status-form"
import { Icons } from "@/components/icons"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/commodity-rates/add",
)({
  component: AddCommodityRatePage,
})

export default function AddCommodityRatePage() {
  const [showAddCommodityRateModal, setShowAddCommodityRateModal] =
    React.useState<boolean>(false)
  return (
    <main>
      <div className="flex w-full justify-end">
        <Button
          onClick={() => {
            {
              if (!validateUserAddPermission()) return
              setShowAddCommodityRateModal(true)
            }
          }}
        >
          <Icons.add className="size-4" />
          Add Commodity Rate
        </Button>
      </div>
      <Credenza
        open={showAddCommodityRateModal}
        onOpenChange={setShowAddCommodityRateModal}
      >
        <CredenzaContent className="flex w-full max-w-[800px] justify-center">
          <CredenzaBody>
            <CommodityRateForm
              setShowAddCommodityRateModal={setShowAddCommodityRateModal}
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
